import React from "react";
import { IAdminPanelProps } from "./AdminPanel.types";
import AdminStyles from "./AdminPanel.styles";
import DROPPED_PIN_LIST from "./DroppedPinList.component";

const ADMIN_PANEL: React.FC<IAdminPanelProps> = (props: IAdminPanelProps) => {
  return (
    <AdminStyles.AdminPanelContainer className="admin-panel-container">
      <DROPPED_PIN_LIST />
    </AdminStyles.AdminPanelContainer>
  );
};

export default ADMIN_PANEL;
